import { render, staticRenderFns } from "./OptionArticleTable.vue?vue&type=template&id=e3c4a214"
import script from "./OptionArticleTable.vue?vue&type=script&lang=ts"
export * from "./OptionArticleTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports